import React, { useEffect, useState } from "react";
import API from "./adminAxios";
import { toast } from "react-toastify";
import { FaUserShield, FaUsers, FaBox, FaWallet, FaArrowAltCircleDown } from "react-icons/fa";

export default function SuperAdminDashboard() {
  const [stats, setStats] = useState({
    totalAdmins: 0,
    totalUsers: 0,
    totalProducts: 0,
    totalDeposit: 0,
    totalWithdraw: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await API.get("/super-admin/stats", {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        setStats(res.data);
      } catch (err) {
        toast.error("Failed to load command stats ❌");
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) return <div style={{ color: "#00f2ff", padding: "40px", textAlign: "center" }}>SYNCING ROOT METRICS...</div>;

  return (
    <div style={{ fontFamily: "'Inter', sans-serif" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", background: "rgba(30, 41, 59, 0.4)", padding: "20px 30px", borderRadius: "20px", border: "1px solid rgba(255,255,255,0.05)" }}>
        <div>
          <h2 style={{ color: "#fff", margin: 0, fontSize: "24px" }}>Command Center Overview</h2>
          <p style={{ color: "#94a3b8", margin: "4px 0 0", fontSize: "14px" }}>Global Multi-Tenant Isolation & Live Platform Statistics</p>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "20px" }}>
        
        {/* Total Admins */}
        <div style={{ background: "rgba(30, 41, 59, 0.3)", padding: "25px", borderRadius: "20px", borderTop: "3px solid #6366f1" }}>
          <FaUserShield size={24} color="#6366f1" style={{ marginBottom: "12px" }} />
          <p style={{ color: "#94a3b8", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", margin: 0 }}>Total Admins</p>
          <h2 style={{ color: "#fff", fontSize: "32px", margin: "8px 0 0" }}>{stats.totalAdmins}</h2>
        </div>

        {/* Total Users */}
        <div style={{ background: "rgba(30, 41, 59, 0.3)", padding: "25px", borderRadius: "20px", borderTop: "3px solid #10b981" }}>
          <FaUsers size={24} color="#10b981" style={{ marginBottom: "12px" }} />
          <p style={{ color: "#94a3b8", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", margin: 0 }}>Total Users</p>
          <h2 style={{ color: "#fff", fontSize: "32px", margin: "8px 0 0" }}>{stats.totalUsers}</h2>
        </div>

        {/* Total Products */}
        <div style={{ background: "rgba(30, 41, 59, 0.3)", padding: "25px", borderRadius: "20px", borderTop: "3px solid #00f2ff" }}>
          <FaBox size={24} color="#00f2ff" style={{ marginBottom: "12px" }} />
          <p style={{ color: "#94a3b8", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", margin: 0 }}>Total Products</p>
          <h2 style={{ color: "#fff", fontSize: "32px", margin: "8px 0 0" }}>{stats.totalProducts}</h2>
        </div>

        {/* Total Deposit */}
        <div style={{ background: "rgba(30, 41, 59, 0.3)", padding: "25px", borderRadius: "20px", borderTop: "3px solid #f59e0b" }}>
          <FaWallet size={24} color="#f59e0b" style={{ marginBottom: "12px" }} />
          <p style={{ color: "#94a3b8", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", margin: 0 }}>Total Deposit</p>
          <h2 style={{ color: "#fff", fontSize: "28px", margin: "8px 0 0" }}>${stats.totalDeposit.toLocaleString()}</h2>
        </div>

        {/* Total Withdraw */}
        <div style={{ background: "rgba(30, 41, 59, 0.3)", padding: "25px", borderRadius: "20px", borderTop: "3px solid #ef4444" }}>
          <FaArrowAltCircleDown size={24} color="#ef4444" style={{ marginBottom: "12px" }} />
          <p style={{ color: "#94a3b8", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", margin: 0 }}>Total Withdraw</p>
          <h2 style={{ color: "#fff", fontSize: "28px", margin: "8px 0 0" }}>${stats.totalWithdraw.toLocaleString()}</h2>
        </div>

      </div>
    </div>
  );
}